import type { TemplateSubSection } from "../PremiseSidebar";
import type { Translate } from "../../i18n/translate";

/**
 * What each template sub-section is called in a toast. Not the sidebar label:
 * that can be renamed per template, and a toast has to read the same everywhere.
 */
export function subNoun(t: Translate, sub: TemplateSubSection): string {
  return t(`templates:templateSubMessages.subNoun.${sub}`);
}

/**
 * Sub-sections that are FORMS: free text, colours, URLs. They are edited in a
 * drawer with one Save. Every other sub-section is a list of discrete actions
 * (a switch, a reorder, a section's own Save) and writes at once.
 */
export const FORM_SUBS: ReadonlySet<TemplateSubSection> = new Set([
  "design",
  "typography",
  "branding",
  "background",
  "wifi",
  "welcome",
  "relatives",
  "instagram",
  "icons",
  "vilmer",
  "menu",
  "custom",
]);
